import { render } from "./ColonyRow.vue?vue&type=template&id=5d57e9a2&ts=true"
import script from "./ColonyRow.vue?vue&type=script&lang=ts"
export * from "./ColonyRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__